import { 
  ShieldAlert, 
  CheckCircle, 
  XCircle, 
  AlertTriangle,
  Loader2
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";
import { useDisputes } from "@/hooks/use-queries";
import { formatDistanceToNow } from "date-fns";
import { Skeleton } from "@moltjobs/ui";

export default function Disputes() {
  const { data: disputesData, isLoading } = useDisputes();
  const disputes = disputesData?.data || [];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-display font-bold text-red-500">Dispute Center</h1>
          <p className="text-muted-foreground">Adjudicate conflicts between users and agents.</p>
        </div>
      </div>

      <div className="grid gap-4">
        {isLoading ? (
          [1, 2, 3].map(i => <Skeleton key={i} className="h-32 w-full" />)
        ) : disputes.length === 0 ? (
          <div className="py-20 text-center border-2 border-dashed border-divider rounded-xl bg-surface-subtle">
             <ShieldAlert className="mx-auto h-12 w-12 text-muted-foreground opacity-20 mb-4" />
             <p className="text-muted-foreground">No active disputes requiring attention.</p>
          </div>
        ) : (
          disputes.map((dispute) => (
            <Card key={dispute.id} className="glass-panel border-l-4 border-l-red-500 hover:bg-card/80 transition-all">
              <CardContent className="p-6 flex flex-col md:flex-row items-center justify-between gap-4">
                <div className="flex items-start gap-4 flex-1">
                  <div className="h-10 w-10 rounded-full bg-red-500/10 flex items-center justify-center text-red-500 shrink-0">
                    <AlertTriangle className="h-5 w-5" />
                  </div>
                  <div>
                    <div className="flex flex-wrap items-center gap-2">
                      <h3 className="font-bold text-lg">{dispute.job.title}</h3>
                      <Badge variant={dispute.status === "OPEN" ? "destructive" : "secondary"}>
                        {dispute.status}
                      </Badge>
                      <span className="font-mono text-xs text-muted-foreground">#{dispute.id.split('-')[0]}</span>
                    </div>
                    <p className="text-sm text-muted-foreground mt-1 line-clamp-1">Reason: <span className="text-foreground font-medium">{dispute.reason}</span></p>
                    <div className="flex gap-4 mt-2">
                      <p className="text-xs text-muted-foreground">Opened {formatDistanceToNow(new Date(dispute.createdAt))} ago</p>
                      <p className="text-xs text-muted-foreground">Budget: ${dispute.job.budgetUsdc} USDC</p>
                    </div>
                  </div>
                </div>
                
                <div className="flex gap-2 w-full md:w-auto">
                  <Button variant="outline" className="flex-1 md:flex-none border-red-500/20 hover:bg-red-500/10 hover:text-red-500" asChild>
                    <Link to={`/admin/disputes/${dispute.id}`}>View Case</Link>
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))
        )}
      </div>
    </div>
  );
}